import storage from 'amkit3-modules/utils/storage'

export const DANMU_SIZE_SMALL = 'small'
export const DANMU_SIZE_MIDDLE = 'middle'
export const DANMU_SIZE_BIG = 'big'

export const DANMU_POSITION_FULL = 'full'
export const DANMU_POSITION_HALF = 'half'
export const DANMU_POSITION_TOP = 'top'
export const DANMU_POSITION_BOTTOM = 'bottom'

export const DANMU_TYPE_LIVE = 'live'
export const DANMU_TYPE_VIDEO = 'video'

export const DANMU_SIZE = {
  [DANMU_SIZE_SMALL]: 20,
  [DANMU_SIZE_MIDDLE]: 22,
  [DANMU_SIZE_BIG]: 25,
}

export const DANMU_POSITION = {
  [DANMU_POSITION_FULL]: [0, 1],
  [DANMU_POSITION_HALF]: [0, 0.5],
  [DANMU_POSITION_TOP]: [0, 0.33],
  [DANMU_POSITION_BOTTOM]: [0.67, 1],
}

export const DANMU_OPACITY = 80

export const DEFAULT_DANMU_OPACITY = +localStorage.getItem('danmuOpacity') || DANMU_OPACITY
export const DEFAULT_DANMU_POSITION = localStorage.getItem('danmuPosition') || DANMU_POSITION_FULL
export const DEFAULT_DANMU_SIZE = localStorage.getItem('videoDanmuSizeMode') || DANMU_SIZE_MIDDLE
export const DEFAULT_DANMU_TYPE =
  localStorage.getItem('danmuType') === null
    ? `${DANMU_TYPE_LIVE},${DANMU_TYPE_VIDEO}`
    : localStorage.getItem('danmuType')
